if ( document.querySelector( '.portfolio-screens-slider' ) ) {
  jQuery( '.portfolio-screens-slider' ).slick( {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    variableWidth: true,
    rows: 0,
    cssEase: 'ease-in-out',
    prevArrow: '<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="M21.388 33.231 6.363 18.206 21.388 3.181" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
    nextArrow: '<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="m3.182 3.182 15.025 15.025L3.182 33.232" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          variableWidth: false
        }
      }
    ]
  } );
}